var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({ 'border-left': 'black' })},[_vm._v(_vm._s(_vm.data.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }